export const importAskNicely = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.type = "text/javascript"

    script.src = "https://static.asknice.ly/dist/standalone/asknicely-in-app-conversation.js"

    script.addEventListener("load", () => resolve(script), false)
    script.addEventListener("error", () => reject(script), false)
    document.body.appendChild(script)
  })
}
